/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Typography, Button, TextField } from "@mui/material";

export const containerStyles = {
  p: 2,
  height: "100%",
  backgroundColor: "#f5f5f5",
};

export const appBarStyles = {
  position: "static",
  color: "transparent",
  elevation: 0,
};

export const toolbarStyles = {
  px: 0,
  minHeight: "auto",
};

export const dividerStyles = {
  borderColor: "#e0e0e0",
};

export const filtersGridStyles = {
  justifyContent: "space-between",
  padding: 1,
  border: "1px solid #e0e0e0",
  mt: 2,
  mb: 2,
};

export const viewTypographyStyles = {
  mt: 1,
  color: "#666",
  fontSize: "0.875rem",
};

export const selectBaseStyles = {
  backgroundColor: "white",
  fontSize: "0.875rem",
  "& .MuiSelect-select": { py: "6px" },
  "&.MuiOutlinedInput-root": {
    height: "2.4rem",
    "&:hover fieldset": { borderColor: "#2b4fb9" },
    "&.Mui-focused fieldset": { borderColor: "#2b4fb9" },
  },
};

export const datePickerStyles = {
  maxWidth: 150,
  backgroundColor: "white",
  fontSize: "0.875rem",
  "& .MuiSelect-select": { py: "6px" },
  "&.MuiOutlinedInput-root": {
    height: "2.4rem",
    "&:hover fieldset": { borderColor: "#2b4fb9" },
    "&.Mui-focused fieldset": { borderColor: "#2b4fb9" },
  },
};

export const updateButtonBaseStyles = {
  fontSize: "0.875rem",
  textTransform: "none",
  fontWeight: 600,
  px: 2,
  border: "1px solid rgba(0,0,0,.12)",
  py: "6px",
};

export const tabsStyles = {
  borderBottom: "1px solid #e0e0e0",
  "& .MuiTabs-flexContainer": { gap: "20px" },
  "& .MuiTab-root": {
    color: "#666",
    fontSize: "0.875rem",
    minWidth: "auto",
    padding: "2px",
    minHeight: "40px",
    px: 0,
    "&:hover": { color: "black" },
  },
  "& .Mui-selected": {
    backgroundColor: "white",
    color: "black !important",
    fontWeight: 600,
    padding: "0px 16px",
  },
  "& .MuiTabScrollButton-root": {
    backgroundColor: "white",
    borderRadius: "40px",
    height: "40px",
  },
};

export const tableHeaderStyles = {
  py: 1,
  "&:last-child": { borderRight: 0 },
};

export const tableSortLabelStyles = {
  fontSize: "0.875rem",
  fontWeight: 600,
  color: "#666",
};

export const tableCellStyles = {
  backgroundColor: "#f5f5f5",
  py: 1,
  fontSize: "0.875rem",
  "&:last-child": { borderRight: 0 },
};

export const perPageStyles = {
  backgroundColor: "white",
  width: 70,
  fontSize: "0.875rem",
  "& .MuiSelect-select": { py: "6px" },
  "&.MuiOutlinedInput-root": {
    height: "2.4rem",
    "&:hover fieldset": {
      borderColor: "#2b4fb9",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#2b4fb9",
    },
  },
}

export const StyledTypography = styled(Typography)({
  color: "black",
  fontSize: "0.875rem",
})

export const ShowHideButton = styled(Button)({
  color: "#2b4fb9",
  backgroundColor: "white",
  border: "1px solid rgba(0,0,0,.12)",
  fontSize: "0.875rem",
  fontWeight: 600,
  textTransform: "none",
})

export const StyledSearchBar = styled(TextField)({
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #2b4fb9 !important'
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: '1px',
    borderRadius: '25px',
  },
  '& .MuiInputBase-root': {
    borderRadius: '25px',
    height: '2.4rem',
    paddingTop: '3px',
    fontSize: '15px',
    width: '253px !important',
    backgroundColor: 'white',
    marginTop: '8px',
  },
})

export const StyledSeachBar = StyledSearchBar
